import React from 'react';
import ChatView from '../chatView/components/ChatView';
import { SESSION_TYPES } from '../chatView/constants';

const AnalysisChat = () => (
    <ChatView
        runPath="runs"
        sessionType={SESSION_TYPES.CHAT}
    />
);

export default AnalysisChat;
